import {
  type PipelineObjectQueries,
  defPipelineObjectQueries,
} from '@kizen/query/pipeline';
import AxiosService from '__services/AxiosService';

const queries: PipelineObjectQueries = defPipelineObjectQueries(AxiosService);

export const allPipelineObjectFieldsQuery: PipelineObjectQueries['allPipelineObjectFieldsQuery'] =
  queries.allPipelineObjectFieldsQuery;

export const pipelineObjectCategoriesQuery: PipelineObjectQueries['pipelineObjectCategoriesQuery'] =
  queries.pipelineObjectCategoriesQuery;

export const pipelineObjectFieldsQuery: PipelineObjectQueries['pipelineObjectFieldsQuery'] =
  queries.pipelineObjectFieldsQuery;
